import React from "react";
import { notify } from "@/shared/utils/notify";
import { ISauceWarehouses } from "../../../../redux/@types";
import { saucesWarehousesService } from "../../../../shared/services";

export const useSauceWarehouses = ({
  warehouseId,
  sauceId,
}: {
  warehouseId?: number;
  sauceId?: number;
}) => {
  const [loading, setLoagding] = React.useState<boolean>(false);
  const [sauceWarehousesInfo, setSauceWarehousesInfo] = React.useState<
  ISauceWarehouses[]
  >([]);

  const sauceWarehouses = async () => {
    if (loading) return;
    setLoagding(true);

    await saucesWarehousesService
      .find({query: {sauce_id: +sauceId!} })
      .then((res: any) => {
        setSauceWarehousesInfo(res.data);
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      })
      .finally(() => {
        setLoagding(false);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (warehouseId || sauceId) {
      sauceWarehouses();
    }
  }, [warehouseId, sauceId]);

  return {
    sauceWarehousesInfo,
    sauceWarehouses,
  };
};
